import { render, staticRenderFns } from "./JobboardSpec.vue?vue&type=template&id=7f22fe2e"
import script from "./JobboardSpec.vue?vue&type=script&lang=js"
export * from "./JobboardSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports